export const transactionEndpoints = {
    salesOrder: {
        list: {
            api: '/api/odyssey/orders/sales',
            method: 'GET',
            parameter: true
        },
        listAll: {
            api: '/api/odyssey/orders/sales/list-all',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/orders/sales/details',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/orders/sales/edit',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/orders/sales/delete',
            method: 'POST',
            parameter: false
        },
        updatePayment: {
            api: '/api/orders/sales/updatePayment',
            method: 'POST',
            parameter: false
        },
        addPayment: {
            api: '/api/orders/sales/payment',
            method: 'POST',
            parameter: false
        },
        addBankTransfer: {
            api: '/api/orders/sales/buyerPayment',
            method: 'POST',
            parameter: false
        },
        restartProcesssing: {
            api: '/api/orders/sales/retry',
            method: 'POST',
            parameter: false
        },
        addTrackingCode: {
            api: '/api/orders/sales/item/track',
            method: 'POST',
            parameter: false
        },
        updateDeliveryStatus: {
            api: '/api/orders/sales/item/manual/status',
            method: 'POST',
            parameter: false
        },
        forceRealease: {
            api: '/api/orders/sales/force/release',
            method: 'POST',
            parameter: false
        }
    },
    purchaseOrder: {
        list: {
            api: '/api/orders/purchase',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/orders/purchase/details',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/orders/purchase/edit',
            method: 'POST',
            parameter: true
        }
    },
    invoice: {
        list: {
            api: '/api/invoices/proforma',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/invoices/proforma/details',
            method: 'GET',
            parameter: true
        },
        disputed:{
            api: '/api/invoices/disputed',
            method: 'POST',
            parameter: false
        }
    },
    customerInvoice:{
        list:{
            api: '/api/invoices',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/invoices/details',
            method: 'GET',
            parameter: true
        },
        buyerList:{
            api: '/api/invoices/list/byaccount',
            method: 'GET',
            parameter: true
        }
    },
    reviews: {
        list: {
            api: '/api/reviews/product',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/reviews/product/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/reviews/product',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/reviews/product',
            method: 'POST',
            parameter: false
        }
    },
    dictionary : {
        bankAccounts: {
            api: '/api/odyssey/configuration/dictionary/bank-account-type',
            method: 'GET',
            parameter: false
        },
        shippingServiceProviders: {
            api: '/api/odyssey/configuration/dictionary/shipping-provider-type',
            method: 'GET',
            parameter: false
        },
        deliveryStatus: {
            api: '/api/odyssey/configuration/dictionary/order-item-delivery-status-type',
            method: 'GET',
            parameter: false
        },
        selections: {
            api: '/api/odyssey/configuration/dictionary/selection-type',
            method: 'GET',
            parameter: false
        },
        operators: {
            api: '/api/odyssey/configuration/dictionary/operator-type',
            method: 'GET',
            parameter: false
        },
        actions: {
            api: '/api/odyssey/configuration/dictionary/level-action-type',
            method: 'GET',
            parameter: false
        },
        policyStatus: {
            api: '/api/odyssey/configuration/dictionary/policy-status',
            method: 'GET',
            parameter: false
        },
        frequency: {
            api: '/api/odyssey/configuration/dictionary/frequency',
            method: 'GET',
            parameter: false
        },
        dayOfTheWeek: {
            api: '/api/odyssey/configuration/dictionary/day-of-the-week',
            method: 'GET',
            parameter: false
        },
        recurrence: {
            api: '/api/odyssey/configuration/dictionary/recurrence',
            method: 'GET',
            parameter: false
        },
        notificationTemplate: {
            api: '/api/templates/dictionary',
            method: 'GET',
            parameter: true
        },
        notificationAction: {
            api: '/api/odyssey/configuration/dictionary/notification-action-type',
            method: 'GET',
            parameter: false
        },
        disputeStatus: {
            api: '/api/odyssey/configuration/dictionary/dispute-status',
            method: 'GET',
            parameter: false
        }
    },
    levelPolicy:{
        list:{
            api: '/api/debtor/policy/level/list',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/debtor/policy/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/debtor/policy/edit',
            method: 'POST',
            parameter: false
        },
        details:{
            api: '/api/debtor/policy/details',
            method: 'GET',
            parameter: true
        },
        delete: {
            api: '/api/debtor/policy/delete',
            method: 'POST',
            parameter: false
        }
    },
    actionPolicy:{
        list:{
            api: '/api/debtor/policy/action/list',
            method: 'GET',
            parameter: true
        }
    },
    rule:{
        add: {
            api: '/api/debtor/rule/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/debtor/rule/edit',
            method: 'POST',
            parameter: false
        },
        details:{
            api: '/api/debtor/rule/details',
            method: 'GET',
            parameter: true
        },
        delete: {
            api: '/api/debtor/rule/delete',
            method: 'POST',
            parameter: false
        }
    },
    disputedInvoice:{
        list:{
            api: '/api/invoices/list/dispute',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/invoices/edit',
            method: 'POST',
            parameter: false
        }
    },
    debtorOverview:{
        list:{
            api: '/api/invoices/list/debtors',
            method: 'GET',
            parameter: true
        }
    },
    agoraAccount:{
        details:{
            api: '/api/agora/account/details/byaccountid',
            method: 'GET',
            parameter: true
        }
    },
    defaultPolicy:{
        details:{
            api: '/api/dm/policy/default',
            method: 'GET',
            parameter: true
        }
    }

};



// WEBPACK FOOTER //
// ./src/endpoints/transaction.endpoints.ts